import { useDispatch } from 'react-redux';

import { triggerPasswordChangeEmail } from 'actions/authentication';
import Button from 'atoms/button';
import toast from 'atoms/toast';

export default function ResetPassword({ data }) {
  const dispatch = useDispatch();

  const onResetPassword = async () => {
    const emailSent = await dispatch(
      triggerPasswordChangeEmail({ email: data.user.email })
    );
    if (emailSent.success) {
      toast({ text: 'Email has been sent!' });
    }
  };
  return (
    <div className="p-24 border-light-purple radius-24 mt-12">
      <h3 className="f16">Reset password</h3>
      <p className="f13 mt-5">
        When you reset a groomer’s password they will receive an email with a
        link to set a new password for their account.
      </p>
      <Button
        onClick={onResetPassword}
        text="Reset password"
        size="small"
        variant="white-outlined"
        className="mt-10 fw-400"
      />
    </div>
  );
}
